import type { FieldKey } from '@jira/polaris__domain-field/src/FieldKey.types.tsx';
import { fireCompoundAnalyticsEvent } from '@jira/polaris__lib-analytics/src/fireCompoundAnalyticsEvent.tsx';
import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { Props, State } from './FieldsUpdate.types.tsx';

const getUpdatedState = (state: State, fieldKey: FieldKey, label: string) => ({
	...state,
	fields: {
		...state.fields,
		[fieldKey]: {
			...state.fields[fieldKey],
			label,
		},
	},
});

export const updateLabel =
	(fieldKey: FieldKey, label: string, createAnalyticsEvent: CreateUIAnalyticsEvent) =>
	async (
		{ getState, setState }: StoreActionApi<State>,
		{ fieldRemote }: Props,
	): Promise<boolean | Error> => {
		try {
			const state = getState();
			if (!state.fields[fieldKey] || state.fields[fieldKey].label === label) {
				return false;
			}

			await fieldRemote.updateField({
				fieldKey,
				name: label,
			});

			setState(getUpdatedState(getState(), fieldKey, label));

			fireCompoundAnalyticsEvent.FieldConfig.labelChangedSuccess(createAnalyticsEvent({}), {
				issueFieldKey: fieldKey,
				issueFieldType: state.fields[fieldKey].type,
			});

			return true;
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			fireCompoundAnalyticsEvent.FieldConfig.labelChangedFailure(createAnalyticsEvent({}));

			return e;
		}
	};
